// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["style/app","style/ui5-theming"], () => (__webpack_require__("./js/app.js")))
__webpack_require__.O(undefined, ["style/app","style/ui5-theming"], () => (__webpack_require__("./style/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["style/app","style/ui5-theming"], () => (__webpack_require__("./style/ui5-theming.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
